import React from "react";

export default function Card({ title, subtitle, actions, className = "", bodyClassName = "", children }) {
	return (
		<div className={`bg-card rounded-card border border-card-bd p-5 ${className}`}>
			{(title || actions) && (
				<div className="flex items-start gap-3 mb-4">
					{title && (
						<div>
							<h3 className="text-base font-bold widget-title-text text-text">{title}</h3>
							{subtitle && <div className="text-xs text-text-3 mt-0.5">{subtitle}</div>}
						</div>
					)}
					{actions && <div className="ml-auto flex items-center gap-2">{actions}</div>}
				</div>
			)}
			<div className={bodyClassName}>{children}</div>
		</div>
	);
}
